import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { MenuItem } from 'react-pro-sidebar';

import classnames from 'classnames';

import { FontAwesomeIcon } from '@hsp/react-component-library';
import { isDefined, isEmpty } from '@hsp/utilities';

import { useFlattenRoutes, useIsAccessible } from 'components/layouts/vertical/components/side-bar/hooks';
import { IMenuItem } from 'types/menu';

import NavHeader from './nav-header';

const NavItem: FC<IMenuItem> = (props) => {
  const { children, className, icon, path, title } = props;

  const flatten = useFlattenRoutes();
  const isAccessible = useIsAccessible();

  if (!isAccessible(props)) {
    return null;
  }

  const flattened = flatten(children ?? []);

  if (!isEmpty(flattened)) {
    const route: IMenuItem = { ...props, children: flattened };

    return <NavHeader {...route} />;
  }

  return (
    <NavLink to={path}>
      {({ isActive }) => (
        <MenuItem
          className={classnames(className, { focused: isActive })}
          icon={
            isDefined(icon) && !isEmpty(icon) ? (
              <FontAwesomeIcon
                icon={icon}
                size="1x"
              />
            ) : null
          }>
          {title}
        </MenuItem>
      )}
    </NavLink>
  );
};

export default NavItem;
